import * as d3 from 'd3';
import { defaultColors } from '@/constants/graphics';

const createColorScale = () => d3.scaleOrdinal().range(defaultColors);

export default createColorScale;
